import React from 'react'
import ReactDOM from 'react-dom'
import { Components } from '@src/containers/PartnersNew'

const formContainers = document.querySelectorAll('.partners-new-calculator')

formContainers.forEach(container => {
  const partnerTab = container.getAttribute('data-partner-tab')
  ReactDOM.render(<Components.PartnersCalculator isNewTab={Boolean(partnerTab)} />, container)
})
